export const TAB_IDS = {
  COMPLETED: "completed",
  UPCOMING: "upcoming"
};
